export default __webpack_public_path__ + "static/media/025-fire-extinguisher.9aed910a.png";